<template>
  <aside class="sidebar">
    <el-menu
      class="elMenuHeight"
      :collapse="collapsed"
      :default-active="defaultActive"
      :default-openeds="defaultOpeneds"
      unique-opened
      router
      @select="selectMenu"
      :class="collapsed?'menu-collaspe-width':'menu-width'"
    >
      <template v-for="(item) in routelist">
        <el-submenu
          v-if="item.childModule.length>0"
          :index="item.moduleCode"
          :key="item.moduleCode"
        >
          <template slot="title">
            <i :class="item.iconic"></i>
            <span slot="title">{{item.moduleName}}</span>
          </template>
          <el-menu-item
            v-for="child in item.childModule"
            :index=" child.url"
            :key="child.moduleCode"
          >{{child.moduleName}}</el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="  '/'+item.url" :key="item.moduleCode">
          <i :class="item.iconic"></i>
          <span slot="title">{{item.moduleName}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </aside>
</template>

<script>
//import hub from "@/assets/js/bus";
export default {
  name: "sidebar",
  data() {
    return {
      collapsed: false,
      routelist: [],
      defaultActive: "",
      defaultOpeneds: []
    };
  },
  created() {
    var sel = this;
    this.$root.Bus.$on("send", function(val) {
      sel.defaultActive = val;
      sel.defaultOpeneds = [];
    });
  },
  mounted() {
    this.GetNaviData();
    this.$root.Bus.$on("change", data => {
      //Hub接收事件
      this.collapsed = data;
    });

    if (this.$route.fullPath !== "") {
      this.defaultActive = this.$route.fullPath;
    }
  },
  methods: {
    //获取菜单列表信息
    GetNaviData() {
      var authInfo = JSON.parse(sessionStorage.getItem("menuList"));
      if (authInfo == null || authInfo.length <= 0) {
        this.routelist = [];
      } else {
        this.routelist = authInfo;
        console.log(this.routelist);
      }
    },
    //选择菜单触发事件
    selectMenu(index, indexPath) {
      console.log(index, indexPath);
      this.defaultActive = index;
    }
  }
};
</script>
